import script from "./BirthdayRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayRequest.vue?vue&type=script&setup=true&lang=js"

import "./BirthdayRequest.vue?vue&type=style&index=0&id=0095a478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0095a478"]])

export default __exports__